import axiosInstance from '../lib/axios';
import type { ContentOperation } from '../types/contentManagement.types';

export const contentManagementService = {
  getContentTree: (params: { year?: number; years?: number[] }) =>
    axiosInstance.get('/content-tree', {
      params: params.years
        ? { years: params.years.join(',') }
        : { year: params.year },
    }),

  getDestinationFolders: (caseId: string) =>
    axiosInstance.get('/content/destination-folders', {
      params: { case_id: caseId },
    }),

  performOperation: (payload: ContentOperation) =>
    axiosInstance.post('/content/operation', {
      ...payload,
      operation_type:
        payload.operation_type.charAt(0).toLowerCase() +
        payload.operation_type.slice(1),
    }),

  getCaseDocuments: (
    caseId: string,
    params?: {
      page?: number;
      limit?: number;
      folder_type?: string;
      hashtags?: string;
    }
  ) => axiosInstance.get(`/cases/${caseId}/documents`, { params }),

  getPendingApprovals: (params?: { page?: number; limit?: number }) =>
    axiosInstance.get('/approvals/pending', { params }),

  getPendingCaseHashtagApprovals: (params?: { page?: number; limit?: number }) =>
    axiosInstance.get('/case-hashtag-approvals/pending', { params }),

  decideDocument: (
    documentId: string,
    payload: { action: 'Approved' | 'Denied'; reason: string }
  ) =>
    axiosInstance.post(`/documents/${documentId}/approve`, {
      action: payload.action === 'Denied' ? 'Rejected' : payload.action,
      reason: payload.reason,
    }),

  getPendingAccessRequests: (params?: { page?: number; limit?: number }) =>
    axiosInstance.get('/access-requests/pending', { params }),

  decideAccessRequest: (
    requestId: string,
    payload: { decision: 'Approved' | 'Denied'; decision_reason: string }
  ) =>
    axiosInstance.post(`/access-requests/${requestId}/decide`, {
      decision: payload.decision === 'Denied' ? 'Rejected' : payload.decision,
      decision_reason: payload.decision_reason,
    }),

  decideCaseHashtagApproval: (
    approvalId: string,
    payload: { action: 'Approved' | 'Denied'; reason: string }
  ) =>
    axiosInstance.post(`/case-hashtag-approvals/${approvalId}/decide`, {
      action: payload.action === 'Denied' ? 'Rejected' : payload.action,
      reason: payload.reason,
    }),
};

export default contentManagementService;
